var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfdetails"},[_c('pdf',{ref:"child",attrs:{"res":_vm.res}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }